import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./SingleTrackingStepComponent.module.css";
import useHelpers from "@hooks/useHelpers";
import ArrowType2SVG from "@/SVGObjects/UiKit/ArrowType2SVG";
var SingleTrackingStepComponent = function SingleTrackingStepComponent(_ref) {
  var text = _ref.text,
    status = _ref.status,
    step = _ref.step,
    status_key = _ref.status_key,
    details = _ref.details,
    isFinance = _ref.isFinance,
    title = _ref.title;
  var _useTranslation = useTranslation(["web_tracking"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.singleStepFSContainer, stl.customShadow, status === "done" ? stl.doneStep : "", status === "current" ? stl.currentStep : "", status === "current" ? stl.customCurrentShadow : "", status === "cancelled" ? stl.errStep : ""].join(" "),
    style: {
      borderColor: status === "current" && step.color
    },
    onClick: function onClick() {
      if (status !== "pending") {
        if (isFinance) {
          navigateTo("/tracking-finance-details/".concat(details.id, "/").concat(status_key));
        } else {
          navigateTo("/tracking-checkout-details/".concat(details.id, "/").concat(status_key));
        }
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.itemTitleBox
  }, status === "done" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/".concat(status, ".svg"),
    alt: "done",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("h5", {
    className: stl.itemTitle
  }, isFinance ? text : title)), status === "cancelled" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/".concat(status, ".svg"),
    alt: "current",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("h5", {
    className: stl.itemTitle
  }, isFinance ? text : title)), status === "current" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/".concat(status, ".svg"),
    alt: "current",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.currentStepContentsFS
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.textContainer
  }, /*#__PURE__*/React.createElement("strong", null, text), (step === null || step === void 0 ? void 0 : step.sub_title) && (step === null || step === void 0 ? void 0 : step.sub_title) !== "" && status === "current" && /*#__PURE__*/React.createElement("div", {
    className: stl.subTitle
  }, status_key !== 2 && /*#__PURE__*/React.createElement("p", {
    style: {
      color: step === null || step === void 0 ? void 0 : step.color,
      textAlign: "left",
      fontWeight: 700
    }
  }, step === null || step === void 0 ? void 0 : step.sub_title), /*#__PURE__*/React.createElement(ArrowType2SVG, {
    filledColor: step === null || step === void 0 ? void 0 : step.color
  }))), /*#__PURE__*/React.createElement("span", null, step !== null && step !== void 0 && step.description ? step === null || step === void 0 ? void 0 : step.description : step === null || step === void 0 ? void 0 : step.sub_text), status === "current" && status_key === 2 && /*#__PURE__*/React.createElement("strong", {
    className: stl.preparePapersStep
  }, step === null || step === void 0 ? void 0 : step.sub_title))), status === "pending" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/".concat(status, ".svg"),
    alt: "pending",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("h5", {
    className: [stl.itemTitle, stl.itemTitleDisabled].join(" ")
  }, text))), status === "done" && /*#__PURE__*/React.createElement("span", {
    className: stl.doneNote
  }, " ", t("done", {
    ns: "web_tracking"
  })), status === "cancelled" && /*#__PURE__*/React.createElement("span", {
    className: stl.errNote
  }, " ", t("request_canceled", {
    ns: "web_tracking"
  }))));
};
export default SingleTrackingStepComponent;